import { toast, ToastOptions, Slide } from "react-toastify"

export const Toast = (message: string, type: string) => {
  const options: ToastOptions<any> = {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: true,
    theme: "colored",
    transition: Slide,
  }

  toast.dismiss()
  switch (type) {
    case "success":
      return toast.success(message, options)
    case "error":
      return toast.error(message, options)
    case "warn":
      return toast.warn(message, options)
    case "info":
      return toast.info(message, options)
    default:
      return toast(message, options)
  }
}
